export const finances = {
  extends: 'Page',
  flow: 'x',
  minHeight: '100vh',
  background: 'ink',
  color: 'inkText',
  NavSidebar: {},
  TabInit: { display: 'none', show: (() => { let d = false; return (el, s) => { if (!d) { d = true; Promise.resolve().then(() => s.root.update({ activeTab: 'finance' })) } return false } })() },

  MainContent: {
    flow: 'y',
    flex: '1',
    overflow: 'auto',

    TopBar: {},

    ContentArea: {
      flow: 'y',
      gap: 'B',
      padding: 'B',
      flex: '1',
      '@mobileL': { padding: 'A' },

      PageHeader: {
        flow: 'x', align: 'center space-between', marginBottom: 'Z',
        TitleWrap: {
          flow: 'y', gap: 'Y',
          PageTitle: { tag: 'h1', text: '{{ finance | polyglot }}', fontSize: 'C', fontWeight: '700', color: 'inkText', letterSpacing: '-0.02em' },
          PageSubtitle: { text: '{{ revenueInvoicesPayments | polyglot }}', fontSize: 'Z', color: 'inkMuted' }
        },
        ExportBtn: {
          tag: 'button', text: '{{ exportReport | polyglot }}',
          fontSize: 'Z', fontWeight: '600', padding: 'Z A', round: 'A',
          background: 'inkSurface', color: 'inkText', border: '1px solid inkBorder', cursor: 'pointer',
          transition: 'all 150ms ease', ':hover': { background: 'inkMid' }
        }
      },

      FinanceStatsRow: {
        flow: 'x', gap: 'A', flexWrap: 'wrap', '@mobileL': { flow: 'y' },
        StatMonthly: {
          flow: 'y', gap: 'Z', padding: 'B', round: 'A', background: 'inkMid', border: '1px solid inkBorder', flex: '1', minWidth: 'E',
          StatLabel: { text: '{{ monthlyRevenue | polyglot }}', fontSize: 'Z', color: 'inkMuted', fontWeight: '500' },
          StatValue: { text: '{{ u20be12400 | polyglot }}', fontSize: 'C', fontWeight: '700', color: 'teal', letterSpacing: '-0.02em' },
          StatTrend: { text: '+18%', fontSize: 'Y', color: 'green', fontWeight: '600' }
        },
        StatPending: {
          flow: 'y', gap: 'Z', padding: 'B', round: 'A', background: 'inkMid', border: '1px solid inkBorder', flex: '1', minWidth: 'E',
          StatLabel: { text: '{{ pending | polyglot }}', fontSize: 'Z', color: 'inkMuted', fontWeight: '500' },
          StatValue: { text: '{{ u20be2100 | polyglot }}', fontSize: 'C', fontWeight: '700', color: 'amber', letterSpacing: '-0.02em' },
          StatTrend: { text: '{{ str208 | polyglot }}', fontSize: 'Y', color: 'green', fontWeight: '600' }
        },
        StatWeek: {
          flow: 'y', gap: 'Z', padding: 'B', round: 'A', background: 'inkMid', border: '1px solid inkBorder', flex: '1', minWidth: 'E',
          StatLabel: { text: '{{ thisWeek | polyglot }}', fontSize: 'Z', color: 'inkMuted', fontWeight: '500' },
          StatValue: { text: '{{ u20be3800 | polyglot }}', fontSize: 'C', fontWeight: '700', color: 'teal', letterSpacing: '-0.02em' }
        }
      },

      ChartSection: {
        flow: 'y', gap: 'A', padding: 'B', round: 'A', background: 'inkMid', border: '1px solid inkBorder',
        ChartTitle: { tag: 'h3', text: '{{ weeklyRevenue | polyglot }}', fontSize: 'A', fontWeight: '700', color: 'inkText' },
        ChartBars: {
          flow: 'x', align: 'flex-end center', gap: 'Z', height: 'F', padding: 'A 0',
          BarMon: { flow: 'y', align: 'center flex-end', flex: '1', gap: 'Y', BarFill: { background: '#0D1117', width: '100%', height: '40%', round: 'X X 0 0' }, BarLabel: { text: '{{ mon2 | polyglot }}', fontSize: 'Y', color: 'inkMuted' } },
          BarTue: { flow: 'y', align: 'center flex-end', flex: '1', gap: 'Y', BarFill: { background: '#0D1117', width: '100%', height: '55%', round: 'X X 0 0' }, BarLabel: { text: '{{ tue2 | polyglot }}', fontSize: 'Y', color: 'inkMuted' } },
          BarWed: { flow: 'y', align: 'center flex-end', flex: '1', gap: 'Y', BarFill: { background: '#0D1117', width: '100%', height: '48%', round: 'X X 0 0' }, BarLabel: { text: '{{ wed2 | polyglot }}', fontSize: 'Y', color: 'inkMuted' } },
          BarThu: { flow: 'y', align: 'center flex-end', flex: '1', gap: 'Y', BarFill: { background: '#0D1117', width: '100%', height: '62%', round: 'X X 0 0' }, BarLabel: { text: '{{ thu2 | polyglot }}', fontSize: 'Y', color: 'inkMuted' } },
          BarFri: { flow: 'y', align: 'center flex-end', flex: '1', gap: 'Y', BarFill: { background: '#0D1117', width: '100%', height: '75%', round: 'X X 0 0' }, BarLabel: { text: '{{ fri2 | polyglot }}', fontSize: 'Y', color: 'inkMuted' } },
          BarSat: { flow: 'y', align: 'center flex-end', flex: '1', gap: 'Y', BarFill: { background: '#0D1117', width: '100%', height: '90%', round: 'X X 0 0' }, BarLabel: { text: '{{ sat2 | polyglot }}', fontSize: 'Y', fontWeight: '700', color: 'inkText' } }
        }
      },

      InvoiceSection: {
        flow: 'y', gap: 'Z', round: 'A', background: 'inkMid', border: '1px solid inkBorder', overflow: 'hidden',
        InvoiceHeader: {
          display: 'grid', gridTemplateColumns: '1fr 2fr 2fr 1fr 80px',
          padding: 'Z A', borderBottom: '1px solid inkBorder', background: 'inkSurface',
          ColInv: { text: '{{ invoice | polyglot }}', fontSize: 'Y', fontWeight: '600', color: 'inkMuted', textTransform: 'uppercase', letterSpacing: '0.05em' },
          ColPat: { text: '{{ patient | polyglot }}', fontSize: 'Y', fontWeight: '600', color: 'inkMuted', textTransform: 'uppercase', letterSpacing: '0.05em' },
          ColSvc: { text: '{{ service | polyglot }}', fontSize: 'Y', fontWeight: '600', color: 'inkMuted', textTransform: 'uppercase', letterSpacing: '0.05em' },
          ColAmt: { text: '{{ amount | polyglot }}', fontSize: 'Y', fontWeight: '600', color: 'inkMuted', textTransform: 'uppercase', letterSpacing: '0.05em', textAlign: 'right' },
          ColSts: { text: '{{ status2 | polyglot }}', fontSize: 'Y', fontWeight: '600', color: 'inkMuted', textTransform: 'uppercase', letterSpacing: '0.05em', textAlign: 'right' }
        },
        InvRow1: {
          display: 'grid', gridTemplateColumns: '1fr 2fr 2fr 1fr 80px',
          padding: 'Z A', borderBottom: '1px solid inkBorder', align: 'center',
          InvNum: { text: '{{ inv001 | polyglot }}', fontSize: 'Z', color: 'inkSubtle' },
          InvPat: { text: '{{ giorgiBeridze | polyglot }}', fontSize: 'Z', color: 'inkText' },
          InvSvc: { text: '{{ checkupXray | polyglot }}', fontSize: 'Z', color: 'inkMuted' },
          InvAmt: { text: '{{ u20be80 | polyglot }}', fontSize: 'Z', fontWeight: '600', color: 'inkText', textAlign: 'right' },
          InvSts: { extends: 'StatusBadge', state: { status: 'Paid' } }
        },
        InvRow2: {
          display: 'grid', gridTemplateColumns: '1fr 2fr 2fr 1fr 80px',
          padding: 'Z A', borderBottom: '1px solid inkBorder', align: 'center',
          InvNum: { text: '{{ inv002 | polyglot }}', fontSize: 'Z', color: 'inkSubtle' },
          InvPat: { text: '{{ ninoKapanadze | polyglot }}', fontSize: 'Z', color: 'inkText' },
          InvSvc: { text: '{{ whitening | polyglot }}', fontSize: 'Z', color: 'inkMuted' },
          InvAmt: { text: '{{ u20be120 | polyglot }}', fontSize: 'Z', fontWeight: '600', color: 'inkText', textAlign: 'right' },
          InvSts: { extends: 'StatusBadge', state: { status: 'Pending' } }
        },
        InvRow3: {
          display: 'grid', gridTemplateColumns: '1fr 2fr 2fr 1fr 80px',
          padding: 'Z A', borderBottom: '1px solid inkBorder', align: 'center',
          InvNum: { text: '{{ inv003 | polyglot }}', fontSize: 'Z', color: 'inkSubtle' },
          InvPat: { text: '{{ davitGelashvili | polyglot }}', fontSize: 'Z', color: 'inkText' },
          InvSvc: { text: '{{ implantPhase1 | polyglot }}', fontSize: 'Z', color: 'inkMuted' },
          InvAmt: { text: '{{ u20be300 | polyglot }}', fontSize: 'Z', fontWeight: '600', color: 'inkText', textAlign: 'right' },
          InvSts: { extends: 'StatusBadge', state: { status: 'Paid' } }
        },
        InvRow4: {
          display: 'grid', gridTemplateColumns: '1fr 2fr 2fr 1fr 80px',
          padding: 'Z A', align: 'center',
          InvNum: { text: '{{ inv004 | polyglot }}', fontSize: 'Z', color: 'inkSubtle' },
          InvPat: { text: '{{ anaJavakhishvili | polyglot }}', fontSize: 'Z', color: 'inkText' },
          InvSvc: { text: '{{ rootCanal | polyglot }}', fontSize: 'Z', color: 'inkMuted' },
          InvAmt: { text: '{{ u20be149 | polyglot }}', fontSize: 'Z', fontWeight: '600', color: 'inkText', textAlign: 'right' },
          InvSts: { extends: 'StatusBadge', state: { status: 'Overdue' } }
        }
      }
    }
  }
}
